import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ViToastService } from '@vi-iot/ui';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsMessageService {
  messages = {
    changeUser: {
      success: '+USER_DETAILS.CHANGED.SUCCESS',
      error: '+USER_DETAILS.CHANGED.ERROR',
    },
    resendConfirmationEmail: {
      success: '+USER_DETAILS.RESENT_EMAIL.SUCCESS',
      error: '+USER_DETAILS.RESENT_EMAIL.ERROR',
    },
    requestPasswordReset: {
      success: '+USER_DETAILS.REQUESTED_RESET_PASSWORD.SUCCESS',
      error: '+USER_DETAILS.REQUESTED_RESET_PASSWORD.ERROR',
    },
  };

  constructor(private translateService: TranslateService, private toastService: ViToastService) {}

  info(message: string): void {
    this.toastService.info({ message: this.translateService.instant(message) });
  }

  error(message: string): void {
    this.toastService.error({ message: this.translateService.instant(message) });
  }
}
